import { init } from 'pp-react-l10n';
const locals =
  JSON.parse(document.getElementById('localeMessages').innerHTML) || {};
const content = {
  locals,
};
init({ content });

let allLocaleMessages;

const getLocaleMessages = (propertyName) => {
  if (!propertyName) {
    console.warn('Missing template name');
  }
  try {
    if (!allLocaleMessages) {
      allLocaleMessages = JSON.parse(
        document.getElementById('localeMessages').innerHTML || {}
      );
    }
    return allLocaleMessages[propertyName] || allLocaleMessages;
  } catch (e) {
    console.warn('Please attach locales to DOM');
    return {};
  }
};

export default getLocaleMessages;
